import React, { useEffect } from "react";
import MenuItemLayout from "../menuItemLayout/MenuItemLayout";
import banner from "../../../assets/images/intern_banner.png";
import mobileBanner from "../../../assets/images/intern-mob.png";
import JobsCollapse from "./JobsCollapse";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import {
  getCertificateForJobs,
  getJobsOpportunities,
} from "../../../apis/actions/jobs.actions";
import Loader from "../../../biblio/Loader/Loader";
import { Col, Row } from "antd";
import DotsLoader from "../../../biblio/Loader/DotsLoader";

const JobsOpportunities = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { jobs, loading, certificateJobs } = useSelector(
    (state: RootState) => state.jobs
  );

  useEffect(() => {
    dispatch(getJobsOpportunities());
    dispatch(getCertificateForJobs());
  }, [dispatch]);
  if (loading) return <Loader />;
  return (
    <MenuItemLayout
      mobileImage={mobileBanner}
      urlImage={banner}
      title="الرئيسية"
      subTitle="التوظيف"
    >
      <Row>
        <Col xxl={2} xl={1} md={0} lg={0} xs={0} sm={0}></Col>
        <Col xxl={20} xl={23} md={24} lg={24} xs={24} sm={24}>
          <div dir="rtl" className="takaful--evaluation">
            <span className="takaful--job-title">الفرص التوظيفية</span>
            {loading ? (
              <div className="takaful--loading-projects-cases">
                <p className="takaful--no-project-message">جارٍ التحميل</p>
                <DotsLoader />
              </div>
            // eslint-disable-next-line eqeqeq
            ) : jobs && jobs.length == 0 ? (
              <p className="takaful--no-services">لا توجد وظائف متاحة</p>
            ) : (
              <JobsCollapse jobs={jobs} certificateJobs={certificateJobs} />
            )}
          </div>
        </Col>
      </Row>
    </MenuItemLayout>
  );
};

export default JobsOpportunities;
